import AdminAccessBoard from "Pages/AdminAccessBoard";
import Authentication from "Pages/Authentication";
import BrokerMaster from "Pages/BrokerMaster";
import CompanyMasterMainPage from "Pages/CompanyMaster";
import CompanyUpdate from "Pages/CompanyMaster/Components/UpdateCompany";
import UniqueCompany from "Pages/CompanyMaster/UniqueCompany";
import Communication from "Pages/Comunication";
import Dashboard from "Pages/Dashboard/Dashboard";
import UserDetail from "Pages/Dashboard/UserDetail";
import Faq from "Pages/Faq";
import Preference from "Pages/Preference";
import PrivateRoute from "PrivateRoute";
import BrokerMasterDetails from "./Pages/BrokerMaster/DetailsPage/index";
import { Navigate, Route, Routes } from "react-router-dom";
import User from "Pages/Dashboard/NewUser/User";
import Details from "Pages/Dashboard/NewUser/Details";

const Routers = () => {
  const isAuthenticated = localStorage.getItem("token");

  return (
    <Routes>
      {!isAuthenticated ? (
        <Route path="/" element={<Authentication />} />
      ) : (
        <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
      )}
      <Route path="/app" element={<PrivateRoute />}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="admin-access-board" element={<AdminAccessBoard />} />
        <Route path="user-details" element={<UserDetail />} />
        <Route path="preference/:id" element={<Preference />} />
        {/* <Route path="advisor/:id/details" element={<AdvisorDetails />} /> */}
        <Route path="broker-master" element={<BrokerMaster />} />
        <Route path="broker-master/:id" element={<BrokerMasterDetails />} />
        <Route path="company-master" element={<CompanyMasterMainPage />} />
        <Route path="user" element={<User />} />
        <Route path="details" element={<Details />} />
        <Route path="advisor/:id/details" element={<Details />} />
        <Route path="preference/:id" element={<Preference />} />
        <Route
          path="company-master/unique-company"
          element={<UniqueCompany />}
        />
        <Route path="company-master/update/:id" element={<CompanyUpdate />} />
        <Route path="faq" element={<Faq />} />
        <Route path="communication" element={<Communication />} />
      </Route>
      <Route path="*" element={<div>Page Not Found</div>} />
    </Routes>
  );
};

export default Routers;
